import React from "react";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import NumberFormat from 'react-number-format';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles(theme => ({
  select:{
    fontSize: '0.75rem',
  },
  option:{
    fontSize:'0.75rem',
 },
 formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Purchase = ({
  onChange,
  disabled,
  error,
  purchase_title,
  purchase,
  comments,
  provinces,
  carstore_contacts,
  onContactsSearch,
  clients,
...props
}) => {

  const getComment = field => {
    var comment = comments.filter(cm => cm.field_name === field)
    if (comment[0])
        return comment[0].comment
        
    return null
  }

  const getLastUpdated = field => {
    var audit = ''
    if (purchase.audits && purchase[field] && purchase[field] !== ''){
        purchase.audits.map((val,idx)=>{
            if (field in val.new_values){
                audit = val.user.name + ' ' +  val.updated_at.substr(0,10)
            }
        })
    }
    return audit;
 }

  const handleChange = event => {
    onChange(event, 'purchase')
  }

  const handleChangeComment = event => {
    onChange(event, 'comments')
  }


  const handleContactsAsyncChange = (event, values) =>{
    if(!values){
        values = {id: ''}
    }
    event.target.value = values.id
    event.target.name = 'contact_id'
    onChange(event, 'purchase')
  }

  const handleContactsAsyncSearch = (event, values) =>{
    onContactsSearch(values)
  }

  const no_usages = [{id:0, name:'No'},{id:1, name:'Si'}];
  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {purchase_title}
      </Typography>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="request_date"
                    name="request_date"
                    label="Fecha de pedido"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese la fecha de pedido"
                    onChange={handleChange}
                    value={purchase.request_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="request_date_comment"
                    name="request_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('request_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="request_date_audit"
                    name="request_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('request_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="estimated_invoice_date"
                    name="estimated_invoice_date"
                    label="Fecha de factura estimada"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de factura estimada"
                    onChange={handleChange}
                    value={purchase.estimated_invoice_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="estimated_invoice_date_comment"
                    name="estimated_invoice_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('estimated_invoice_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="estimated_invoice_audit"
                    name="estimated_invoice_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('estimated_invoice_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="invoice_date"
                    name="invoice_date"
                    label="Fecha de factura"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de factura"
                    onChange={handleChange}
                    value={purchase.invoice_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="invoice_date_comment"
                    name="invoice_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('invoice_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="invoice_audit"
                    name="invoice_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('invoice_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="invoice_recepction_date"
                    name="invoice_recepction_date"
                    label="Fecha de recepcion factura"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de recepción factura"
                    onChange={handleChange}
                    value={purchase.invoice_recepction_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="invoice_recepction_date_comment"
                    name="invoice_recepction_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('invoice_recepction_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="invoice_recepction_date_audit"
                    name="invoice_recepction_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('invoice_recepction_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>        
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="estimated_plate_date"
                    name="estimated_plate_date"
                    label="Fecha de estimada patentamiento"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha estimada patentamiento."
                    onChange={handleChange}
                    value={purchase.estimated_plate_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="estimated_plate_date_comment"
                    name="estimated_plate_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('estimated_plate_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="plate_date_audit"
                    name="plate_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('estimated_plate_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="payment_date"
                    name="payment_date"
                    label="Fecha de pago"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese de fecha de pago"
                    onChange={handleChange}
                    value={purchase.payment_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="payment_date_comment"
                    name="payment_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('payment_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="payment_date_audit"
                    name="payent_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('payment_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="documents_reception_date"
                    name="documents_reception_date"
                    label="Fecha de recepción doc"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese de recepción de doc."
                    onChange={handleChange}
                    value={purchase.documents_reception_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="documents_reception_date_comment"
                    name="documents_reception_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('documents_reception_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="doc_reception_audit"
                    name="doc_recepcion_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('documents_reception_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="plate_delivered_date"
                    name="plate_delivered_date"
                    label="Fecha de entrega chapas"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de entrega de chapas."
                    onChange={handleChange}
                    value={purchase.plate_delivered_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="plate_delivered_date_comment"
                    name="plate_delivered_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('plate_delivered_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="plate_delivered_date_audit"
                    name="plate_delivered_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('plate_delivered_plate')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="estimated_vehicle_delivered_date"
                    name="estimated_vehicle_delivered_date"
                    label="Fecha de estimada de entrega"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de estimada de entrega."
                    onChange={handleChange}
                    value={purchase.estimated_vehicle_delivered_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="estimated_vehicle_delivered_date_comment"
                    name="estimated_vehicle_delivered_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('estimated_vehicle_delivered_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="estimated_vehicle_date_audit"
                    name="estimated_vehicle_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('estimated_vehicle_delivered_plate')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>        
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="vehicle_delivered_date"
                    name="vehicle_delivered_date"
                    label="Fecha de retiro unidad"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de entrega de vehiculo."
                    onChange={handleChange}
                    value={purchase.vehicle_delivered_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="vehicle_delivered_date_comment"
                    name="vehicle_delivered_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('vehicle_delivered_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="vehicle_date_audit"
                    name="vehicle_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('vehicle_delivered_plate')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='no_usage' >Pedido de no rodamiento
                    <Select native name='no_usage'
                        inputProps={{
                            name:"no_usage",
                            className:"no_usage"
                        }}
                        style={{minWidth: 150, fontSize: '0.75rem'}}
                        disabled={disabled}
                        onChange={handleChange}
                        value={purchase.no_usage}
                        input={<Input id="grouped-native-select" name='no_usage'/>}>
                        <option value="" />
                        {no_usages.map((no_usage) => <option id={no_usage.id} value={no_usage.id}>{no_usage.name}
                        </option>)}
                    </Select> 
                </FormControl>
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="no_usage_comment"
                    name="no_usage_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('no_usage')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="no_usage_audit"
                    name="no_usage_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('no_usage')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-2">
                <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='invoice_province_id' >Provincia patentamiento
                    <Select native name='invoice_province_id'
                        inputProps={{
                            name:"invoice_province_id",
                            className:"invoice_province_id"
                        }}
                        style={{minWidth: 150, fontSize: '0.75rem'}}
                        disabled={disabled}
                        onChange={handleChange}
                        value={purchase.invoice_province_id}
                        input={<Input id="grouped-native-select" name='invoice_province_id'/>}>
                        <option value="" />
                        {provinces.map((province) => <option id={province.id} value={province.id}>{province.name}
                        </option>)}
                    </Select> 
                </FormControl>
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="invoice_province_id_comment"
                    name="invoice_province_id_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('invoice_province_id')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="invoice_province_id_audit"
                    name="invoice_province_id_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('invoice_province_id')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>  
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="invoice_number"
                    name="invoice_number"
                    label="Numero de factura"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese numero de factura."
                    onChange={handleChange}
                    value={purchase.invoice_number}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="invoice_number_comment"
                    name="invoice_number_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('invoice_number')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="invoice_number_audit"
                    name="invoice_number_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('invoice_number')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
        <div className="row">
            <div className="col-md-2">
                <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='invoice_province_id' >Concesionaria
                    <Autocomplete
                        id={"contact_id"}
                        style={{ width: '100%' }}
                        getOptionLabel={(option) => option.hansa_name}
                        getOptionSelected={(option, value) => option.hansa_name === value}           
                        options={carstore_contacts.options}
                        loading={carstore_contacts.loading}
                        value={(purchase.contact_id) ? carstore_contacts.options.find(v => v.id === purchase.contact_id) || {} : {}}
                        onInputChange={handleContactsAsyncSearch}
                        onChange={handleContactsAsyncChange.bind(this)}
                        autoComplete
                        noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
                        name={"contact_id"}
                        includeInputInList
                        className="mr-2"
                        classes={{
                            option: classes.option,
                        }}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Ingrese un contacto"
                            name={"contact_id"}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                    {carstore_contacts.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                                }}
                                InputLabelProps={{ ...params.InputLabelProps,
                                        shrink: true
                                        }}
                                inputProps={{
                                            ...params.inputProps,
                                            style:{fontSize: '0.75rem', width: 70}
                                        }}

                        />
                        )}
                    />
                </FormControl>
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="carstore_name_comment"
                    name="carstore_name_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('carstore_name')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="carstore_name_audit"
                    name="carstore_name_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('carstore_name')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
        <div className="row">
            <div className="col-md-2">
                <TextField
                    id="due_date"
                    name="due_date"
                    label="Fecha de vencimiento"
                    disabled={disabled}
                    type="date"
                    placeholder="Ingrese fecha de vencimiento."
                    onChange={handleChange}
                    value={purchase.due_date}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="due_date_comment"
                    name="due_date_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('due_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="due_date_audit"
                    name="due_date_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('due_date')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
        <div className="row">
            <div className="col-md-2">
                <NumberFormat 
                    id={"price_buy"}
                    name={"price_buy"}
                    label="Precio de compra"
                    placeholder="Ingrese el precio de compra"
                    value={purchase.price_buy}
                    onChange={handleChange}
                    className="mt-3 p-0"
                    InputProps={{style: {minWidth: 100,fontSize: '0.75rem'}}}
                    decimalSeparator='.'
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    customInput={TextField}  
                    InputLabelProps={{
                    shrink: true,
                    }}
                    isAllowed={(values) => {
                    let { floatValue } = values;
                    floatValue = (floatValue !== undefined) ? floatValue : 0
                        return floatValue >= 0 && floatValue < 99999999;
                    }}            

                />								          
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="price_buy_comment"
                    name="price_buy_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('price_buy')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="price_buy_audit"
                    name="price_buy_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('price_buy')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
        <div className="row">
            <div className="col-md-2">
            <NumberFormat 
                    id="price_list"
                    name="price_list"
                    label="Precio de lista"
                    placeholder="Ingrese precio de lista."
                    value={purchase.price_list}
                    onChange={handleChange}
                    className="mt-3 p-0"
                    InputProps={{style: {minWidth: 100,fontSize: '0.75rem'}}}
                    decimalSeparator='.'
                    prefix={'$'}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    customInput={TextField}  
                    InputLabelProps={{
                    shrink: true,
                    }}
                    isAllowed={(values) => {
                    let { floatValue } = values;
                    floatValue = (floatValue !== undefined) ? floatValue : 0
                        return floatValue >= 0 && floatValue < 99999999;
                    }}            

                />								          
            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="price_list_comment"
                    name="price_list_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('price_list')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="price_list_audit"
                    name="price_list_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('price_list')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
        <div className="row">
            <div className="col-md-2">
            <FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='destiny_client_id' >
                <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Cliente solicitante</InputLabel>
                <Select native name='destiny_client_id'
                    inputProps={{
                    name:"destiny_client_id",
                    className:"destiny_client_id"
                    }}
                    style={{minWidth: 150, fontSize: '0.75rem'}}
                    disabled={disabled}
                    onChange={handleChange}
                    error={(error !=='' && purchase.destiny_client_id ==='') ? 'Debe completar este campo' :  false }
                    value={purchase.destiny_client_id}
                    input={<Input id="grouped-native-select" name='destiny_client_id'/>}>
                    <option value="" />
                        {clients.map((client) => <option id={client.id} value={client.id}>{client.business_name}
                    </option>)}
                </Select>
            </FormControl>

            </div>
            <div className="col-md-6 mr-auto">
                <TextField
                    id="destiny_client_id_comment"
                    name="destiny_client_id_comment"
                    label="Comentario"
                    disabled={disabled}
                    type="text"
                    placeholder="Ingrese un comentario"
                    onChange={handleChangeComment}
                    value={getComment('destiny_client_id')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth                    
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
            <div className="col-md-4 mr-auto">
                <TextField
                    id="destiny_client_id_audit"
                    name="destiny_client_id_audit"
                    label="Ult. modificacion"
                    disabled={true}
                    type="text"
                    onChange={handleChangeComment}
                    value={getLastUpdated('destiny_client_id')}
                    margin="normal"
                    className="mr-2 "
                    InputLabelProps={{
                        shrink: true
                    }}
                    fullWidth
                    inputProps={{style:{minWidth: '100%', fontSize: '0.75rem'}}} 
                />
            </div>
        </div>                
    </React.Fragment>
    )
}

export default Purchase;

